module.exports = __webpack_public_path__ + "assets/1792649897182/img/word-icon.9c1569a9.png";